export {
  default as Pagination,
  type PaginationProps,
  type ItemsPerPage,
} from './Pagination';
